import { GREY_COLORS, PARKER_GOLDEN_COLORS } from '@config/theme/colors'
import { FontSize, FontWeight } from '@config/theme/sizes'
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
	palette: {
		primary: {
			main: GREY_COLORS[800]
		},
		secondary: {
			main: PARKER_GOLDEN_COLORS[200]
		}
	},
	components: {
		MuiButton: {
			defaultProps: {
				variant: 'outlined'
			},
			styleOverrides: {
				root: {
					borderColor: GREY_COLORS[200],
					height: '40px'
				},
				contained: {
					boxShadow: 'none',
					'&:hover': {
						boxShadow: 'none'
					}
				}
			}
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					height: '40px',
					'& .MuiInputBase-root': {
						height: '40px'
					},
					'& .MuiOutlinedInput-root': {
						'& .MuiOutlinedInput-notchedOutline': {
							border: `1px solid ${GREY_COLORS[200]}`
						},

						'&:hover .MuiOutlinedInput-notchedOutline': {
							border: `1px solid ${GREY_COLORS[200]}`
						},

						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							border: `1px solid ${GREY_COLORS[200]}`
						}
					}
				}
			}
		}
	},
	typography: {
		button: {
			textTransform: 'none'
		},
		allVariants: {
			lineHeight: 'auto'
		},
		h1: {
			fontSize: FontSize.XXXL,
			fontWeight: FontWeight.REGULAR
		},
		h2: {
			fontSize: FontSize.XXL,
			fontWeight: FontWeight.MEDIUM
		},
		h3: {
			fontSize: FontSize.XL,
			fontWeight: FontWeight.REGULAR
		},
		h4: {
			fontSize: FontSize.LG,
			fontWeight: FontWeight.REGULAR
		},
		h5: {
			fontSize: FontSize.BASE,
			fontWeight: FontWeight.REGULAR
		},
		subtitle1: {
			fontSize: FontSize.MD,
			fontWeight: FontWeight.BOLD
		},
		subtitle2: {
			fontSize: FontSize.XS,
			fontWeight: FontWeight.REGULAR
		},
		body1: {
			fontSize: FontSize.BASE,
			fontWeight: FontWeight.REGULAR
		},
		body2: {
			fontSize: FontSize.MD,
			fontWeight: FontWeight.REGULAR
		}
	}
})

export default theme
